<template>
    <b-progress :height="height" class="w-100">
        <b-progress-bar :style="`background-color: ${defaultColorProgress}`" :value="value" :max="max">
            <span :style="`color: ${defaultLabelColor}`">{{ defaultLabel }}</span>
        </b-progress-bar>
    </b-progress>
</template>

<script>
export default {
    name: 'ProgressBar',
    props: {
        value: {
            type: Number,
            required: false,
            default: 0,
        },
        height: {
            type: String,
            required: false,
            default: '5px',
        },
        color: {
            type: String,
            required: false,
        },
        labelColor: {
            type: String,
            required: false,
        },
        label: {
            type: String,
            required: false,
        },
        max: {
            type: Number,
            required: false,
            default: 100,
        },
        useDefaultLabel: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            colors: {
                warning: '#f05050',
                progress: '#fad732',
                success: '#27c24c',
            },
        }
    },
    computed: {
        defaultLabel() {
            // eslint-disable-next-line
            return this.label
                ? this.label
                : this.useDefaultLabel
                ? Math.ceil(this.value) + '%'
                : ''
        },
        defaultLabelColor() {
            // eslint-disable-next-line
            return this.labelColor
                ? this.labelColor
                : this.value === 0
                ? '#bec0c0'
                : '#fff'
        },
        defaultColorProgress() {
            return this.color
                ? this.color
                : this.value < 30
                ? this.colors.warning
                : this.value < 70
                ? this.colors.progress
                : this.colors.success
        },
    },
}
</script>
